module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create":"Create article"}}')
  delete Component.options._Ctor
}
